module.exports = __webpack_public_path__ + "static/media/bh01.00703f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bh01.jpg
// module id = 376
// module chunks = 0